import { render } from "./OidoGridRow.vue?vue&type=template&id=6c844c81&scoped=true"
import script from "./OidoGridRow.vue?vue&type=script&lang=js"
export * from "./OidoGridRow.vue?vue&type=script&lang=js"

import "./OidoGridRow.vue?vue&type=style&index=0&id=6c844c81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c844c81"]])

export default __exports__